import { graphAtom } from "@features/run/RunGroupDialog/atoms"
import { RunGroupFormValues } from "@features/run/RunGroupDialog/RunGroupForm"
import { getEligibleWhatIfContractOptions } from "@features/run/RunModelForm/helpers"
import { FormHelperText, MenuItem, Select, Stack, Typography } from "@mui/material"
import { permissionsAtom } from "@store/authAtoms"
import { getErrorMessage } from "@utils/form"
import { useAtomValue } from "jotai"
import { Controller, useFormContext } from "react-hook-form"

export const RunGroupFieldContractKey = () => {
  const graph = useAtomValue(graphAtom)
  const {
    control,
    formState: { errors },
  } = useFormContext<RunGroupFormValues>()

  const permissions = useAtomValue(permissionsAtom)

  if (!graph) return null

  // only `whatif` permissions allow a user to run sampling, even if they can view this item
  const contractOptions = getEligibleWhatIfContractOptions(graph.base_graph_family_key, permissions)

  return (
    <Stack sx={{ mt: 2 }} spacing={1}>
      {contractOptions.length > 1 && (
        <>
          <Typography variant={"h6"}>
            You are a member of multiple eligible contracts for this base graph. Who should be able
            to see these sampling run(s)?
          </Typography>
          <Typography>Please select which contract to assign this sampling run to.</Typography>
          <Typography>
            BEWARE: This affects who can see this sampling run and it's results.{" "}
            <b>Confirm first.</b>
          </Typography>
          <Controller
            name="contract_key"
            control={control}
            render={({ field }) => (
              <>
                <Select
                  error={Boolean(errors[field.name])}
                  displayEmpty
                  sx={{ fontSize: "small", mt: 1 }}
                  {...field}
                >
                  {contractOptions.map((contractKey) => (
                    <MenuItem key={contractKey.contract_key} value={contractKey.contract_key}>
                      {contractKey.description} - {contractKey.contract_key}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText error>{getErrorMessage(errors, field.name)}</FormHelperText>
              </>
            )}
          />
        </>
      )}

      {contractOptions.length === 1 && (
        <>
          <Typography>Accessible by users on Contract</Typography>
          <Controller
            name="contract_key"
            control={control}
            render={({ field }) => (
              <>
                <Select
                  error={Boolean(errors[field.name])}
                  sx={{ fontSize: "small", mt: 1 }}
                  {...field}
                >
                  <MenuItem
                    key={contractOptions[0]?.contract_key}
                    value={contractOptions[0]?.contract_key}
                  >
                    {contractOptions[0]?.contract_key}
                  </MenuItem>
                </Select>
                <FormHelperText error>{getErrorMessage(errors, field.name)}</FormHelperText>
              </>
            )}
          />
        </>
      )}
    </Stack>
  )
}
